import Utils from '@/common/utils/utils';
import Constant from "@/common/constant/Constant";
const { useState, useEffect } = require("react");

function LiveChatMention({message,listAgentData}) {
    const [messageState,setMessagesState] = useState(message);
    const [innerHtmlState, setInnerHtmlState] = useState('');

    useEffect(()=> {
        let content = messageState.content;
        const mention = messageState.mention
        if(Utils.isEmptyArray(mention)){
            setInnerHtmlState(`<p>${content}</p>`)  
        }else{
            mention?.forEach((userId) =>{
                if (userId !== 'ALL') {
                    const agentData = listAgentData.find(agent => agent.id === userId);
                    let name = Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, agentData, false);
                    content = content.replace(`@[${userId}]`, `<a>@${name}</a>`);
                }else{
                    content = content.replace(`@[${userId}]`, `<a>@all</a>`);  
                }
                
            })
            setInnerHtmlState(`${content}`) 
        }
    },[messageState])
    return(
        <div className="message-text" dangerouslySetInnerHTML={{
            __html: Utils.replaceUrls(
                Utils.escapeHtmlCharacters(innerHtmlState),
                false,
                false,
                ''
            )
        }}></div>
    )
}

export default LiveChatMention